<template>
  <div>
    <div class="row">
      <div class="col-12 mt-4">
        <div class="press-release-block">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6>{{ date }}</h6>
            <button
                v-if="showDownload"
                class="btn btn-primary"
                @click="downloadPDF"
                :disabled="isDownloading"
            >
              <i v-if="isDownloading" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-download"></i>
            </button>
          </div>
          <h4>{{ title }}</h4>
          <KeyHighlights v-if="enableAI" :highlights="keyHighlights" :loading="isLoadingHighlights"/>
          <span v-html="content">
          </span>
        </div>
      </div>
    </div>
    <AIAnalysisPopup v-if="enableAI" :enable-a-i="enableAI" :analysis-summary="analysisSummary"
                     :key-highlights="keyHighlights" :title="title" :date="date" source="Press Release"
                     :press-release-url="link"/>
  </div>
</template>


<script>
import axios from 'axios'
import moment from 'moment'
import AIAnalysisPopup from '../common/AIAnalysisPopup.vue'
import KeyHighlights from '../common/KeyHighlights.vue'

export default {
  components: {
    AIAnalysisPopup,
    KeyHighlights
  },
  metaInfo() {
  },
  props: {
    accountId: {
      type: String
    },
    newsId: {
      type: String
    },
    source: {
      type: String
    },
    enableAI: {
      type: Boolean
    },
    showDownload: {
      type: Boolean
    }
  },
  data() {
    return {
      title: '',
      date: '',
      content: '',
      analysisSummary: '',
      keyHighlights: [],
      isLoadingHighlights: false,
      link: '',
      isDownloading: false
    }
  },
  methods: {
    async getData() {
      let response = await axios.get(`news/details?accountId=${this.accountId}&newsId=${this.newsId}`);
      const res = response.data;
      if (res && res.status) {
        const details = res.value;
        this.title = details.title;
        this.link = details.link;
        this.date = moment(details.date, 'YYYY-MM-DDTHH:mm:ssZ').format('MMM DD, YYYY hh:mma');
        this.content = details.htmlDocument;
      }
    },
    async getAnalysisSummary() {
      this.isLoadingHighlights = true;
      try {
        const response = await axios.get(`https://investably-app.uc.r.appspot.com/api/news/analysis/v2?accountId=${this.accountId}&newsId=${this.newsId}`);
        if (response.data) {
          this.analysisSummary = response.data.summary || '';
          this.keyHighlights = response.data.keyHighlights || [];
        }
      } catch (e) {
        this.analysisSummary = '';
        this.keyHighlights = [];
      } finally {
        this.isLoadingHighlights = false;
      }
    },
    async downloadPDF() {
      this.isDownloading = true;
      try {
        const response = await axios.get(`/news/pdf?accountId=${this.accountId}&newsId=${this.newsId}`, {
          responseType: 'blob'
        });

        // Create a blob from the PDF Stream
        const file = new Blob([response.data], {type: 'application/pdf'});

        // Create a URL for the blob
        const fileURL = window.URL.createObjectURL(file);

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `${this.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.pdf`;

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(fileURL);
      } catch (error) {
        console.error('Error downloading PDF:', error);
        // You might want to show an error message to the user here
      } finally {
        this.isDownloading = false;
      }
    }
  },
  mounted() {
    this.getData();
    if (this.enableAI) {
      this.getAnalysisSummary();
    }
  }
}
</script>
